const formatResourceString = (input: string) => {
	const stringAfterDot = input.split(".")[1];

	const words = stringAfterDot.replace(/([A-Z])/g, " $1").trim();

	const formattedString = words
		.split(" ")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(" ");

	return formattedString;
};

export default formatResourceString;
